<template>
  <div>
    <!-- BANNER -->
    <Banner />

    <!-- BASIC INFO + COUNTDOWN -->
    <div class="service-banner section-gap" id="info">
      <div class="container">
        <div class="section-title-wrapper">
          <div class="fullscreen-row">
            <div
              v-if="render"
              class="col-sm-12 mx-auto text-center section-title-wrapper splash-s splash-container d-flex"
              style="padding-top: 30px;"
            >
              <h1 class="white h1-larger">
                {{ this.grundinfo.description.fields.title }}
              </h1>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 mx-auto section-title-wrapper text-center">
              <Countdown date="August 15, 2016"></Countdown>
            </div>
          </div>
          <div class="row">
            <div
              v-if="render"
              class="col-sm-12 mx-auto text-center section-title-wrapper"
            >
              <vm id="vm" class="mb-0 white lead p-info">
                {{ this.grundinfo.description.fields.beschreibung }}
              </vm>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xs-6 padding-lr">
                <a href="#" class="btn btn-lg" v-scroll-to="'#event'" ><span>anmeldung</span></a>   
           </div>
            <div class="col-xs-6 padding-lr" v-if="!this.showButton">
             <a href="#" class="btn btn-lg" v-scroll-to="'#throwback'" ><span>throwback</span></a>
            </div>
             <div class="col-xs-6 padding-lr" v-if="!this.showButton">
                <a href="#" class="btn btn-lg" v-scroll-to="'#team'" ><span>team</span></a>
             </div>
             <div class="col-xs-6 padding-lr" v-if="this.showButton">
             <router-link class="btn btn-lg" to="/livestream">
            Livestream
          </router-link>
            </div>
             <div class="col-xs-6 padding-lr" v-if="this.showButton">
                <router-link class="btn btn-lg" to="/gewinnspiel">
            Gewinnspiel
          </router-link>
             </div>
          </div>
        </div>
      </div>
    </div>

    <!-- VIDEO LAST YEAR -->
    <div class="wrap-bg">
      <div class="">
        <VideoSection id="throwback"/>
      </div>
    </div>

    <Portfoliov2 />

    <!-- TEAM -->
    <TeamGridV2 id="team"></TeamGridV2>

    <Info/>

    <Prizes />
    <!-- EVENT LIST -->
    <div id="event" class="eventSection d-flex align-items-center min-vh-100">
      <EventList />
    </div>

    <!-- JUICER -->
    <div class="service mob-feature">
      <div class="section-gap">
        <div class="container">
          <JuicerFeed />
        </div>
      </div>
    </div>

    <Sponsors />
    <!-- CONTACT -->
    <div id="sponsors" class="contact-section" style="background: black">
      <!-- <ContactInfo></ContactInfo> -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Banner from "@/components/Banner/Banner.vue";
import TeamGridV2 from "Components/Sections/TeamGridV2.vue";
import ContactInfo from "Components/Sections/ContactInfo.vue";
import VideoSection from "Components/Sections/VideoSection.vue";
import Countdown from "Components/Sections/Counter.vue";
import Portfoliov2 from "@/views/Pages/PortfolioV2.vue";
import JuicerFeed from "Components/Sections/JuicerFeed.vue";
import EventList from "Components/Sections/EventList.vue";
import Sponsors from "Components/Sections/Sponsors.vue";
import Info from "Components/Sections/Info.vue";
import Prizes from "Components/Sections/Prizes.vue";
import client from "../utils/api.js";
import VueMarkdown from "vue-markdown";

export default {
  data() {
    return {
      render: false,
      currentDate: null,
      showButton: false,
      grundinfo: {
        title: "",
        description: ""
      }
    };
  },
  components: {
    Banner,
    Prizes,
    Sponsors,
    Info,
    TeamGridV2,
    ContactInfo,
    VideoSection,
    Countdown,
    Portfoliov2,
    JuicerFeed,
    EventList,
    vm: VueMarkdown
  },
  methods: {
    scroll() {
      console.log(document.getElementById('sponsors'))
      document.getElementById('info').scrollIntoView({
  behavior: 'smooth'
});
    },
    checkDate(){
      if(this.currentDate >= new Date(2020, 9, 14) && this.currentDate <= new Date(2020, 10, 1)) {
        this.showButton = true;
      } else {
        this.showButton = false;
      }
    }
  },
  created() {
    //Get Grundinfo
    client
      .getEntries({ content_type: "grundinfo", order: "-sys.createdAt" })
      .then(response => {
        this.grundinfo.description = response.items[0];

        this.render = true;
      });

    //Date check
    //JJJJ MM DD
    //Note: month 9 = October, 10 = November
    this.currentDate = new Date() //use this
    // this.currentDate = new Date(2020, 9, 14) //use for testing
   this.checkDate()
  }
};
</script>

<style scoped>
.service {
  min-height: 100vh;
  background-color: black;
}
.service-banner {
  background-color: black;
  background-image: url(/static/img/controller10.png);
  background-repeat: no-repeat;
  background-position: 105% 100%;
}

.service-banner h2 {
  color: #fff;
}

.wrap-bg {
  background: url(/static/img/background_muster_10.png);
  background-position: 100% 100%;
  background-color: black;
  background-size: cover;
  background-attachment: fixed;
}

.eventSection {
  background: black;
  background-image: url(/static/img/controller10.png);
  background-repeat: no-repeat;
  background-position: 110% 0%;
  background-size: 35%;
}
.p-larger {
  font-size: 1.75em !important;
}
.white {
  color: white !important;
}
.h1-larger {
  font-size: 4.5em;
}

@media (hover: none) {
  .wrap-bg {
    background-attachment: initial !important;
    background-position: center !important;
  }
}
@media screen and (min-width: 1300px) {
  .p-info {
    font-size: 1.5em !important;
  }
}
/*Mobile Phones*/
@media screen and (max-width: 600px) {
  .h1-larger {
    font-size: 3em;
  }

  .splash-s {
    background-image: url(/static/img/splash-l.png),
      url(/static/img/splash-r.png);
    background-position: -25% 13%, 85% 55% !important;
    background-repeat: no-repeat, no-repeat;
    background-size: 140px, 70px;
    min-height: 200px;
  }
}

/*Tablet*/
@media screen and (min-width: 601px) and (max-width: 1000px) {
  .h1-larger {
    font-size: 3em;
  }
  .p-larger {
    font-size: 1.25em !important;
  }
  .splash-s {
    background-image: url(/static/img/splash-l.png),
      url(/static/img/splash-r.png);
    background-position: 10% 13%, 70% 55% !important;
    background-repeat: no-repeat, no-repeat;
    background-size: 180px, 90px;
    min-height: 200px;
  }
}

/*XR*/
@media screen and (width: 828px) and (height: 1792px) {
  .h1-larger {
    font-size: 4.5em !important;
  }
  .row > div > .p-larger {
    font-size: 1.9em !important;
  }
  .fullscreen-row > .splash-s {
    background-image: url(/static/img/splash-l.png),
      url(/static/img/splash-r.png);
    background-position: -5% -30%, 75% 60% !important;
    background-repeat: no-repeat, no-repeat;
    background-size: 220px, 130px;
    min-height: 200px;
  }
}

.splash-s {
  background-image: url(/static/img/splash-l.png), url(/static/img/splash-r.png);
  background-position: 6% -58%, 63% 78%;
  background-repeat: no-repeat;
  min-height: 200px;
}
.splash-container {
  justify-content: center;
  align-items: center;
}

.fullscreen-row {
  width: 100vw;
  position: relative;
  left: calc(-50vw + 50%);
}

.fullscreen-row:before,
.fullscreen-row:after {
  display: table;
  content: " ";
}
#vm > p {
  color: white !important;
}
.fullscreen-row:after {
  clear: both;
}
.btn{
            background-color:transparent;
            color: #eb6626;
            min-width: 140px;
            border:2px solid #eb6626!important;
            border-radius: 0px !important;
            font-size: 17px;
            font-weight: 700;
            position: relative;
            letter-spacing: 1px;
            text-transform: uppercase;
            z-index: 1;
            transition: all 0.6s ease 0s;
            overflow: hidden;
            line-height: 2.5 !important;
        }
        .btn:hover{
            color: #fff !important;
        }
        .btn:before{
            background: #eb6626;
            content: "";
            height: 1000px;
            left: 50%;
            opacity: 1;
            position: absolute;
            top: 50%;
            transform: translateX(-50%) translateY(-50%) rotate(45deg);
            transition: all 0.2s linear 0s;
            width: 0;
            z-index: -1;
        }
        .btn:hover:before{
            opacity: 1;
            width: 100%;
        }

.padding-lr {
  padding: 10px 10px;
}

</style>
